import {ProvincesModel} from "./../provinces/provinces.model";
import {LeadsStatusType, LeadsReasonType} from "./leads.type";

export interface LeadsModel {
    id?: number,
    telephone: string,
    schedule_time?: string,
    company_name?: string,
    address?: string,
    city?: string,
    status: LeadsStatusType,
    province?: ProvincesModel,
    postal_code?: string,
    contact?: string,
    created_at?: number,
    updated_at?: number,
    visible?: number,
    reason?: number
}
export interface LeadUpdateModel {
    company_name?: string,
    address?: string,
    city?: string,
    province_id?: number,
    postal_code?: string,
    contact?: string,
    telephone?: string,
    new_opener_id?: number
}
export interface LeadsFilter {
    limit?: number,
    page?: number,
    sort?: string,
    order?: string,
    opener_id?: number,
    difference?: string,
    fields?: Array<any>,
    q?: string,
}

export interface AssignOpenerToLeads {
    quantity: number,
    opener?: Array<number>
}

export interface LeadScheduleModel {
    schedule_time: string,
    note?: string
}

export interface LeadStatusModel {
    status: LeadsStatusType,
    reason?: LeadsReasonType
}

export class NewLeadModel implements LeadsModel{
    telephone: string;
    status: LeadsStatusType;
    contact: string;
    company_name: string;

    closer_id:string = null;
    industry_id:string = null;
}


// WEBPACK FOOTER //
// ./src/app/models/leads/leads.model.ts